import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const carousels = document.querySelectorAll('.carousel-quote');

carousels.forEach((carouselElement, index) => {
    carouselElement.classList.add(`carousel-quote-${index}`);

    const swiper = new Swiper(`.carousel-quote-${index}`, {
        modules: [Navigation, Pagination],
        a11y:true,
        speed: 400,
        spaceBetween: 100,
        loop:false,
        centeredSlides: false,
        breakpointBase: 'window',
        slidesPerView: 1,
        slideClass: 'quote-item',
        navigation: {
            addIcons: false,
            nextEl: `.carousel-quote-${index} .quote-next`,
            prevEl: `.carousel-quote-${index} .quote-prev`,
        },
        pagination: {
            el: `.carousel-quote-${index} .swiper-pagination`,
            clickable: true,
        },
    });
});


